// src/pages/StudentLogin.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaSignInAlt,
  FaEye,
  FaEyeSlash,
  FaMoon,
    FaHome,
} from "react-icons/fa";

import BASE_URL from "../config";

export default function StudentLogin() {
  const [aadhar, setAadhar] = useState("");
  const [showAadhar, setShowAadhar] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const [darkMode, setDarkMode] =
    useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    if (aadhar.length !== 12) {
      alert(
        "Please enter valid 12-digit Aadhaar Number"
      );
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_URL}/api/student/login`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
          },
          body: JSON.stringify({ aadhar }),
        }
      );

      const data = await response.json();

      if (data.success) {
        localStorage.setItem(
          "student",
          JSON.stringify(data.student)
        );

        navigate("/student-dashboard");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);

      alert("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        ...styles.page,
        background: darkMode
          ? "#081126"
          : "#0d1240",
      }}
    >
      {/* BACKGROUND OVERLAY */}
      <div style={styles.overlay} />

      {/* LOGIN CARD */}
      <div
        style={{
          ...styles.card,
          background: darkMode
            ? "rgba(16,25,50,0.92)"
            : "rgba(255,255,255,0.92)",

          color: darkMode
            ? "#fff"
            : "#111",
        }}
      >
        {/* TOP ORANGE BAR */}
        <div style={styles.topBar}>
          <div style={styles.logoCircle}>
            🎓
          </div>
        </div>

        {/* SCHOOL NAME */}
        <h2
          style={{
            ...styles.schoolName,
            color: darkMode
              ? "#5ea2ff"
              : "#1b65ff",
          }}
        >
         ಶ್ರೀ ಪವಾಡ ಬಸವೇಶ್ವರ ಶಾಲೆ
        </h2>

        {/* TITLE */}
        <h3
          style={{
            ...styles.title,
            color: darkMode
              ? "#fff"
              : "#1792d2",
          }}
        >
          Student Login
        </h3>

        {/* LABEL */}
        <div style={styles.label}>
          Enter Aadhaar Number
        </div>

        {/* INPUT BOX */}
        <div style={styles.inputWrapper}>
          <input
            type={
              showAadhar
                ? "text"
                : "password"
            }
            value={aadhar}
            maxLength={12}
            onChange={(e) =>
              setAadhar(
                e.target.value.replace(
                  /\D/g,
                  ""
                )
              )
            }
            placeholder="Enter Aadhaar Number"
            style={{
              ...styles.input,
              background: darkMode
                ? "#111b35"
                : "#fff",

              color: darkMode
                ? "#fff"
                : "#111",

              border: darkMode
                ? "1px solid #35538a"
                : "1px solid #ccc",
            }}
          />

          <button
            style={styles.eyeBtn}
            onClick={() =>
              setShowAadhar(!showAadhar)
            }
          >
            {showAadhar ? (
              <FaEyeSlash />
            ) : (
              <FaEye />
            )}
          </button>
        </div>

        {/* LOGIN BUTTON */}
        <button
          style={styles.loginBtn}
          onClick={handleLogin}
          disabled={loading}
        >
          <FaSignInAlt />

          {loading
            ? "Please Wait..."
            : "Login"}
        </button>

        {/* LINE */}
        <div style={styles.line} />

        {/* BOTTOM BUTTONS */}
<div style={styles.bottomBtns}>
  {/* HOME BUTTON */}
  <button
    style={styles.homeBtn}
    onClick={() => navigate("/")}
  >
    <FaHome />
    Home
  </button>

  {/* DARK MODE BUTTON */}
  <button
    style={styles.darkBtn}
    onClick={() =>
      setDarkMode(!darkMode)
    }
  >
    <FaMoon />
    Toggle Dark Mode
  </button>
</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",

    backgroundImage:
      "url('https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=2070&auto=format&fit=crop')",

    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: 20,
    fontFamily:
      "'Segoe UI', sans-serif",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "rgba(7,15,70,0.75)",
    backdropFilter: "blur(2px)",
  },

  card: {
    width: "100%",
    maxWidth: 400,
    borderRadius: 22,
    padding: "28px 30px",
    position: "relative",
    zIndex: 5,

    boxShadow:
      "0 15px 50px rgba(0,0,0,0.35)",

    backdropFilter: "blur(15px)",
  },

  topBar: {
    width: "100%",
    height: 28,
    background: "#f4a021",
    borderRadius: 4,
    position: "relative",
    marginBottom: 22,
  },

  logoCircle: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: "#fff",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    top: -10,

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    fontSize: 22,

    border: "3px solid #f4a021",
  },

  schoolName: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.4,
    marginBottom: 18,
  },

  title: {
    textAlign: "center",
    marginBottom: 30,
    fontSize: 28,
    fontWeight: "700",
  },

  label: {
    fontSize: 18,
    marginBottom: 12,
    fontWeight: "500",
  },

  inputWrapper: {
    position: "relative",
    marginBottom: 22,
  },

  input: {
    width: "100%",
    height: 58,
    borderRadius: 12,
    paddingLeft: 18,
    paddingRight: 55,
    fontSize: 18,
    outline: "none",
    boxSizing: "border-box",
  },

  eyeBtn: {
    position: "absolute",
    right: 14,
    top: "50%",
    transform: "translateY(-50%)",

    background: "transparent",
    border: "none",
    cursor: "pointer",

    fontSize: 20,
    color: "#666",
  },

  loginBtn: {
    width: "100%",
    height: 58,

    border: "none",
    borderRadius: 12,

    background:
      "linear-gradient(135deg,#1e6bff,#0a58ff)",

    color: "#fff",

    fontSize: 22,
    fontWeight: "700",

    cursor: "pointer",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,

    boxShadow:
      "0 8px 20px rgba(30,107,255,0.4)",

    transition: "0.3s",
  },

  line: {
    height: 1,
    background: "#ccc",
    margin: "30px 0",
  },

  darkBtn: {
    margin: "auto",
    display: "flex",
    alignItems: "center",
    gap: 10,

    padding: "12px 18px",

    borderRadius: 10,
    border: "1px solid #999",

    background: "#efefef",

    cursor: "pointer",

    fontSize: 15,
    fontWeight: "600",
  },
  bottomBtns: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 15,
  flexWrap: "wrap",
},

homeBtn: {
  flex: 1,
  minWidth: 140,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,

  padding: "13px 18px",

  borderRadius: 12,
  border: "none",

  background:
    "linear-gradient(135deg,#ff9800,#ff6a00)",

  color: "#fff",

  cursor: "pointer",

  fontSize: 16,
  fontWeight: "700",

  boxShadow:
    "0 8px 20px rgba(255,152,0,0.35)",

  transition: "0.3s",
},

darkBtn: {
  flex: 1,
  minWidth: 160,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,

  padding: "13px 18px",

  borderRadius: 12,
  border: "none",

  background:
    "linear-gradient(135deg,#4b5563,#111827)",

  color: "#fff",

  cursor: "pointer",

  fontSize: 16,
  fontWeight: "700",

  boxShadow:
    "0 8px 20px rgba(0,0,0,0.25)",

  transition: "0.3s",
},
};